import { HOME_PAGE } from '@/app/constants';
import { MEDAL_CONFIGS } from './constants';
import type { Medal } from './types';

/**
 * 获取勋章图标URL
 */
export const getMedalIcon = (medal?: Medal): string | null => {
  if (!medal?.user_medal_type || medal.user_medal_type === 'unspecified') return null;

  const config = MEDAL_CONFIGS[medal.user_medal_type];
  return config?.icon || null;
};

/**
 * 获取勋章配置
 */
export const getMedalConfig = (medal?: Medal) => {
  if (!medal?.user_medal_type || medal.user_medal_type === 'unspecified') return null;
  return MEDAL_CONFIGS[medal.user_medal_type] || null;
};

/**
 * 判断勋章是否使用标准展示形式
 * 默认返回 true，只有配置为 'special' 的勋章才返回 false
 */
export const isStandardDisplay = (medal?: Medal): boolean => {
  if (!medal?.user_medal_type || medal.user_medal_type === 'unspecified') {
    return false;
  }
  const config = MEDAL_CONFIGS[medal.user_medal_type];
  return config?.displayType !== 'special';
};

/**
 * 判断勋章是否支持下载海报
 */
export const hasPosterSupport = (medal?: Medal): boolean => {
  if (!medal?.user_medal_type || medal.user_medal_type === 'unspecified') {
    return false;
  }
  const config = MEDAL_CONFIGS[medal.user_medal_type];
  return config?.downloadable === true;
};

export const getPageNameForReport = (pathname: string): string => {
  if (pathname.includes('/activity/sect-war')) {
    return 'Activity_SectWars';
  }
  if (pathname.includes(HOME_PAGE)) {
    return 'Home';
  }
  if (pathname.includes('/explore')) {
    return 'Explore';
  }
  if (pathname.includes('/profile')) {
    return 'Profile';
  }
  return pathname || 'Unknown';
};
